import { useQuery } from "react-query";
import servicesUtils from "../../../../utils/servicesUtils";

const useGetConversations = (workspaceId, patientId = null, isEnabled) => {
  return useQuery(
    ["conversations", workspaceId, patientId],
    () =>
      servicesUtils.getService(
        `/llm_orchestrator/workspaces/${workspaceId}/conversations`,
        {
          patient_id: patientId,
        }
      ),
    {
      enabled: !!workspaceId && isEnabled,
      staleTime: 0,
      cacheTime: 2000,
      refetchOnMount: true,
      refetchOnWindowFocus: false,
    }
  );
};

export default useGetConversations;
